
// import the interface

import { CrudsActionType, CrudStateAction } from '../actions/crud.action';
import { CrudState } from '../models/crud-state.model';
//create a dummy initial state
const initialState: CrudState ={
  success:false,
  error:null
};
export function crudReducer(state: CrudState = initialState,action: CrudStateAction) {
  switch (action.type) {
    case CrudsActionType.GET:
    
      return {
        ...state,
        success: true,
        error: null
      };
    case CrudsActionType.POST:
      
        return {
          ...state,
          success: true,
          error: null
        };
    case CrudsActionType.FAILED:
      return {
        ...state,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
}

